import { memo, useMemo, useCallback } from "react";
import { usePendingActions } from "../context/pendingActionsContext";
import PendingActionSnackbar from "./PendingActionSnackbar";

const PendingActionToasts = () => {
  const { syncedEntries, expiredEntries, clearSyncedEntry, clearExpiredEntry } =
    usePendingActions();

  // Get the first synced/expired entry for toast display (process one at a time)
  const firstSynced = useMemo(() => {
    const entries = Array.from(syncedEntries.entries());
    if (entries.length === 0) return null;
    return {
      signature: entries[0][0],
      actionType: entries[0][1].actionType,
      summary: entries[0][1].summary,
    };
  }, [syncedEntries]);

  const firstExpired = useMemo(() => {
    const entries = Array.from(expiredEntries.entries());
    if (entries.length === 0) return null;
    return {
      signature: entries[0][0],
      actionType: entries[0][1].actionType,
      summary: entries[0][1].summary,
    };
  }, [expiredEntries]);

  const handleCloseSynced = useCallback(() => {
    if (firstSynced) {
      clearSyncedEntry(firstSynced.signature);
    }
  }, [firstSynced, clearSyncedEntry]);

  const handleCloseExpired = useCallback(() => {
    if (firstExpired) {
      clearExpiredEntry(firstExpired.signature);
    }
  }, [firstExpired, clearExpiredEntry]);

  return (
    <>
      {firstSynced && (
        <PendingActionSnackbar
          open={true}
          onClose={handleCloseSynced}
          type="synced"
          actionType={firstSynced.actionType}
          summary={firstSynced.summary}
        />
      )}
      {firstExpired && (
        <PendingActionSnackbar
          open={true}
          onClose={handleCloseExpired}
          type="expired"
          actionType={firstExpired.actionType}
          summary={firstExpired.summary}
        />
      )}
    </>
  );
};

export default memo(PendingActionToasts);
